import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IconArrowBottomBold } from 'components/icons/icon-arrow-bottom-bold';

export const IconArrowBottomBoldWithLine = ({
  className, icons, isActive, classNamesDottedLine: { classNameIconDottedLineSm, classNameIconDottedLineLg },
}) => {
  const [IconDottedLineSm, IconDottedLineLg] = icons;

  return (
    <div className={className}>
      {isActive && (
        <IconArrowBottomBold
          className="d-none d-sm-block"
        />
      )}
      <IconDottedLineSm className={classNames({ 'mt-n2_5': !isActive }, classNameIconDottedLineSm)} />
      <IconDottedLineLg className={classNames(classNameIconDottedLineLg)} />
    </div>
  );
};

IconArrowBottomBoldWithLine.propTypes = {
  className: PropTypes.string.isRequired,
  classNamesDottedLine: PropTypes.shape().isRequired,
  icons: PropTypes.arrayOf(PropTypes.func),
  isActive: PropTypes.bool.isRequired,
};

IconArrowBottomBoldWithLine.defaultProps = {
  icons: null,
};
